export default __webpack_public_path__ + "static/media/goBackArrow.c5486972.svg";